/**
 * @see https://www.w3.org/TR/png/#5DataRep
 */
export const chunkSizes = {
    /** Number of bytes reserved for chunk type */
    LENGTH: 4,
    /** Number of bytes reserved for chunk type */
    TYPE: 4,
    /** Number of bytes reserved for chunk CRC */
    CRC: 4,
} as const;

export const chunkTypes: Record<string, number[]> = {
    signature: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a],
    /** `IEND` chunk */
    trailer: [0x49, 0x45, 0x4e, 0x44],
    /** `IHDR` chunk type */
    imageHeader: [0x49, 0x48, 0x44, 0x52],
    /** `PLTE` chunk type */
    palette: [0x50, 0x4c, 0x54, 0x45],
    /** `acTL` chunk type */
    animationControl: [0x61, 0x63, 0x54, 0x4c],
    /** `IDAT` chunk type */
    imageData: [0x49, 0x44, 0x41, 0x54],
    /** `IEND` chunk type */
    imageEnd: [0x49, 0x45, 0x4e, 0x44],
};
